module.exports = __webpack_public_path__ + "static/media/m_45.8587d0a9.png";